export default "__VITE_ASSET__CQI_kD1r__"